/**
 *      ev04_cpf.js
 *          Script de ev02_16pf.vue
 *          Valida los valres ingresados, calcula los resultados y genera la grafica en un PDF.
 */
/* ======================================================================================================== */
import moment from 'moment'
import ingreso from './ingreso.vue'

import Vue from 'vue';
import jsPDF from 'jspdf'
Vue.use(jsPDF)

import { store } from './../store/store'

// import 'materialize-css/dist/css/materialize.min.css'
import M from 'materialize-css'

export default {
     name: 'sociabilidad',
     components: {
          'moment': moment,
          'input-date': ingreso,
     },
     template: `#formacpf`,
     data() {
          return {
               ejemplo: {},
               eval_cpf: {}, res: {},
               modo: "",
               eval_fecha: new Date(),
               instrucciones: "",
               inicioeval: false, finalizoeval: false, grabado: false,
               pregSinContestar: 0, ejeSinResponder: 0,

               //? .....................................................................................................................................................................................................................
               activott1:"active", activott2: '!active',
               vertt1: true, vertt2: false, 

          } // return
     }, // data()
     mounted() {

          /** Definiciones para el uso de los slides y tooltips */
          var elems = document.querySelectorAll('.collapsible');
          var instances = M.Collapsible.init(elems, {});

          var elems = document.querySelectorAll('.tooltipped');
          var instances = M.Tooltip.init(elems, {});

          var elem = document.querySelectorAll('.tabs');
          var instances = M.Tabs.init(elem, {});

          /** obtiene localmente el caso definido en el almacén (store) */
          this.cargaEvaluacion();
     },
     computed: {
          l_sinResponder() {
               return this.sinContestar();
          },
          l_ejeSinResponder() {
               return this.ejeSinContestar();
          },
     },
     methods: {

          crearPDF() {

               /** CREACION DEL ARCHIVO PDF */
               var cadena = this.eval_cpf.nombre,
                    patron = / /g,
                    nuevoValor = "",
                    nusuario = cadena.replace(patron, nuevoValor);

               var nArchivo = "cpf_" + nusuario;
               console.log("archivo a crear ? ", nArchivo);

               var imagen = "data:image/jpeg;base64,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";
               var doc = new jsPDF('portrait');
               var linea = 5;

               /** Muestra el logo.        (izq, top, ancho, alto) */
               doc.addImage(imagen, 'JPEG', 155, linea, 50, 20);
               /** fila, columna */

               /** CIRCULOS  */
               doc.setLineWidth(1);                    // Grosor de la línea del borde
               doc.setDrawColor(0);

               /** ................................................................................................................ 
               /* TEXTO INTRODUCTORIO */
               let meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

               var lhoy = new Date();
               //lhoy=   lhoy.toString();
               var ldia = lhoy.getDate();
               var lmes = meses[lhoy.getMonth()];
               var lanio = lhoy.getFullYear();

               // console.log("lhoy ? ",lhoy);
               // console.log("ldia ? ",ldia,", lmes ? ",lmes,", lanio ? ",lanio);
               doc.setFontSize(9);
               doc.text(10, 20, "Ciudad de Guatemala, " + ldia + " de " + lmes + " de " + lanio);
               doc.text(10, 30, "Evaluación de SOCIABILIDAD para " + this.eval_cpf.nombre + " de " + this.eval_cpf.empresa + " ( " + this.eval_cpf.depto + " )");

               this.respuestas(doc);
               this.resultados(doc);

               doc.save(nArchivo);
               doc.autoPrint();
               window.open(doc.output('bloburl'), '_blank');
          },
          rangosnpf() {

               switch (this.eval_cpf.pg001) {
                    case 'a': this.res_cpf.Dos = this.res_cpf.Dos + 2; console.log("Es a)");
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1; console.log("Es b)");
                         break;
                    case 'c': this.res_cpf.Cero = this.res_cpf.Cero + 1; console.log("Es c)");
                         break;
               }
               console.log("uno ? ", this.res_cpf.Uno, "; dos ? ", this.res_cpf.Dos, "; Cero ? ", this.res_cpf.Cero);


               /* Resuelve para la pregunta 2 */
               switch (this.eval_cpf.pg002) {
                    case 'a': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }
               /* Resuelve para la pregunta 3 */
               switch (this.eval_cpf.pg003) {
                    case 'a': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }
               /* Resuelve para la pregunta 4 */
               switch (this.eval_cpf.pg004) {
                    case 'a': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }
               /* Resuelve para la pregunta 5 */
               switch (this.eval_cpf.pg005) {
                    case 'a': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }
               /* Resuelve para la pregunta 6 */
               switch (this.eval_cpf.pg006) {
                    case 'a': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }

               /* Resuelve para la pregunta 3 */
               switch (this.eval_cpf.pg007) {
                    case 'a': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }
               /* Resuelve para la pregunta 4 */
               switch (this.eval_cpf.pg008) {
                    case 'a': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }

               /* ======================================================== */
               /* CASO ESPECIAL */
               /* Resuelve para la pregunta 9 */
               /* ======================================================== */
               switch (this.eval_cpf.pg009) {
                    case 'a': this.res_cpf.Cero2 = this.res_cpf.Cero2 + 1;
                         break;
                    case 'b': this.res_cpf.Uno2 = this.res_cpf.Uno2 + 1;
                         break;
                    case 'c': this.res_cpf.Dos2 = this.res_cpf.Dos2 + 2;
                         break;
               }
               /* Resuelve para la pregunta 4 */
               switch (this.eval_cpf.pg010) {
                    case 'a': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }

               /* Resuelve para la pregunta 4 */
               switch (this.eval_cpf.pg011) {
                    case 'a': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }

               /* Resuelve para la pregunta 4 */
               switch (this.eval_cpf.pg012) {
                    case 'a': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }
               /* Resuelve para la pregunta 4 */
               switch (this.eval_cpf.pg013) {
                    case 'a': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }

               /* ======================================================== */
               /* CASO ESPECIAL */
               /* Resuelve para la pregunta 14 */
               /* ======================================================== */
               switch (this.eval_cpf.pg014) {
                    case 'a': this.res_cpf.Dos2 = this.res_cpf.Dos2 + 2;
                         break;
                    case 'b': this.res_cpf.Uno2 = this.res_cpf.Uno2 + 1;
                         break;
                    case 'c': this.res_cpf.Cero2 = this.res_cpf.Cero2 + 1;
                         break;
               }
               switch (this.eval_cpf.pg015) {
                    case 'a': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }

               /* Resuelve para la pregunta 16 */
               switch (this.eval_cpf.pg016) {
                    case 'a': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }
               /* Resuelve para la pregunta 17 */
               switch (this.eval_cpf.pg017) {
                    case 'a': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }
               switch (this.eval_cpf.pg018) {
                    case 'a': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }
               /* ======================================================== */
               /* CASO ESPECIAL */
               /* Resuelve para la pregunta 19 */
               /* ======================================================== */
               console.log("a evaluar 19")
               switch (this.eval_cpf.pg019) {
                    case 'a': this.res_cpf.Dos2 = this.res_cpf.Dos2 + 2;
                         break;
                    case 'b': this.res_cpf.Uno2 = this.res_cpf.Uno2 + 1; console.log("19 es b !!")
                         break;
                    case 'c': this.res_cpf.Cero2 = this.res_cpf.Cero2 + 1;
                         break;
               }
               switch (this.eval_cpf.pg020) {
                    case 'a': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }

               /* Resuelve para la pregunta 17 */
               switch (this.eval_cpf.pg021) {
                    case 'a': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }
               switch (this.eval_cpf.pg022) {
                    case 'a': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }
               /* ======================================================== */
               /* CASO ESPECIAL */
               /* Resuelve para la pregunta 23 */
               /* ======================================================== */
               switch (this.eval_cpf.pg023) {
                    case 'a': this.res_cpf.Cero2 = this.res_cpf.Cero2 + 1;
                         break;
                    case 'b': this.res_cpf.Uno2 = this.res_cpf.Uno2 + 1;
                         break;
                    case 'c': this.res_cpf.Dos2 = this.res_cpf.Dos2 + 2;
                         break;
               }
               switch (this.eval_cpf.pg024) {
                    case 'a': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }
               switch (this.eval_cpf.pg025) {
                    case 'a': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }
               switch (this.eval_cpf.pg026) {
                    case 'a': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }
               switch (this.eval_cpf.pg027) {
                    case 'a': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }
               /* ======================================================== */
               /* CASO ESPECIAL */
               /* Resuelve para la pregunta 28 */
               /* ======================================================== */
               switch (this.eval_cpf.pg028) {
                    case 'a': this.res_cpf.Dos2 = this.res_cpf.Dos2 + 2;
                         break;
                    case 'b': this.res_cpf.Uno2 = this.res_cpf.Uno2 + 1;
                         break;
                    case 'c': this.res_cpf.Cero2 = this.res_cpf.Cero2 + 1;
                         break;
               }
               switch (this.eval_cpf.pg029) {
                    case 'a': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }
               switch (this.eval_cpf.pg030) {
                    case 'a': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }
               switch (this.eval_cpf.pg031) {
                    case 'a': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }
               switch (this.eval_cpf.pg032) {
                    case 'a': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }
               switch (this.eval_cpf.pg033) {
                    case 'a': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }
               switch (this.eval_cpf.pg034) {
                    case 'a': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }
               switch (this.eval_cpf.pg035) {
                    case 'a': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }
               switch (this.eval_cpf.pg036) {
                    case 'a': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }
               /* ======================================================== */
               /* CASO ESPECIAL */
               /* Resuelve para la pregunta 37 */
               /* ======================================================== */
               switch (this.eval_cpf.pg037) {
                    case 'a': this.res_cpf.Cero2 = this.res_cpf.Cero2 + 1;
                         break;
                    case 'b': this.res_cpf.Uno2 = this.res_cpf.Uno2 + 1;
                         break;
                    case 'c': this.res_cpf.Dos2 = this.res_cpf.Dos2 + 2;
                         break;
               }
               switch (this.eval_cpf.pg038) {
                    case 'a': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }
               switch (this.eval_cpf.pg039) {
                    case 'a': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }
               switch (this.eval_cpf.pg040) {
                    case 'a': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }
               console.log(">>> PRIMERAS 15 PREGUNTAS");
               console.log("pg1 ? ", this.eval_cpf.pg001, "pg2 ? ", this.eval_cpf.pg002, "pg3 ? ", this.eval_cpf.pg003, "pg4 ? ", this.eval_cpf.pg004, "pg5 ? ", this.eval_cpf.pg005,
                    "pg6 ? ", this.eval_cpf.pg006, "pg7 ? ", this.eval_cpf.pg007, "pg8 ? ", this.eval_cpf.pg008, "pg9 ? ", this.eval_cpf.pg009, "pg10 ? ", this.eval_cpf.pg010,
                    "pg11 ? ", this.eval_cpf.pg011, "pg12 ? ", this.eval_cpf.pg012, "pg13 ? ", this.eval_cpf.pg013, "pg14 ? ", this.eval_cpf.pg014, "pg15 ? ", this.eval_cpf.pg015,
                    "pg16 ? ", this.eval_cpf.pg016, "pg17 ? ", this.eval_cpf.pg017, "pg18 ? ", this.eval_cpf.pg018, "pg19 ? ", this.eval_cpf.pg019, "pg20 ? ", this.eval_cpf.pg020,
                    "pg21 ? ", this.eval_cpf.pg021, "pg22 ? ", this.eval_cpf.pg022, "pg23 ? ", this.eval_cpf.pg023, "pg24 ? ", this.eval_cpf.pg024, "pg25 ? ", this.eval_cpf.pg025,
                    "pg26 ? ", this.eval_cpf.pg026, "pg27 ? ", this.eval_cpf.pg027, "pg28 ? ", this.eval_cpf.pg028, "pg29 ? ", this.eval_cpf.pg029, "pg30 ? ", this.eval_cpf.pg030,
                    "pg31 ? ", this.eval_cpf.pg031, "pg32 ? ", this.eval_cpf.pg032, "pg33 ? ", this.eval_cpf.pg033, "pg34 ? ", this.eval_cpf.pg034, "pg35 ? ", this.eval_cpf.pg035,
                    "pg36 ? ", this.eval_cpf.pg036, "pg37 ? ", this.eval_cpf.pg037, "pg38 ? ", this.eval_cpf.pg038, "pg39 ? ", this.eval_cpf.pg039, "pg40 ? ", this.eval_cpf.pg040);
               console.log("uno ? ", this.res_cpf.Uno, "; dos ? ", this.res_cpf.Dos, "; Cero ? ", this.res_cpf.Cero);
               console.log("uno2 ? ", this.res_cpf.Uno2, "; dos2 ? ", this.res_cpf.Dos2, "; Cero2 ? ", this.res_cpf.Cero2);

               console.log("**");
               console.log("uno ? ", this.res_cpf.Uno, "; dos ? ", this.res_cpf.Dos, "; Cero ? ", this.res_cpf.Cero);
               console.log("uno2 ? ", this.res_cpf.Uno2, "; dos2 ? ", this.res_cpf.Dos2, "; Cero2 ? ", this.res_cpf.Cero2);

               this.res_cpf.cprevia = this.res_cpf.Uno + this.res_cpf.Dos;
               this.res_cpf.cpreviaIzq = 0;
               this.res_cpf.cpreviaDer = this.res_cpf.Uno2 + this.res_cpf.Dos2;
               if (this.res_cpf.cpreviaDer >= 1000000) {
                    this.res_cpf.cpreviaIzq = this.res_cpf.cprevia - this.res_cpf.cpreviaDer;
               } else {
                    this.res_cpf.cpreviaIzq = this.res_cpf.cprevia;
               }

               /* ================================================================================================= */
               /*  COMPARADOR DE RANGOS */
               this.res_cpf.rango= -1;
               let comp1 = (this.res_cpf.cpreviaIzq >= 21 && this.res_cpf.cpreviaIzq <= 25);
               if (comp1 === true) {
                    this.res_cpf.rango = 1;
               }
               let comp2 = (this.res_cpf.cpreviaIzq >= 26 && this.res_cpf.cpreviaIzq <= 28);
               if (comp2 === true) {
                    this.res_cpf.rango = 2;
               }
               let comp3 = (this.res_cpf.cpreviaIzq >= 29 && this.res_cpf.cpreviaIzq <= 31);
               if (comp3 === true) {
                    this.res_cpf.rango = 3;
               }
               let comp4 = (this.res_cpf.cpreviaIzq >= 32 && this.res_cpf.cpreviaIzq <= 34);
               if (comp4 === true) {
                    this.res_cpf.rango = 4;
               }
               let comp5 = (this.res_cpf.cpreviaIzq >= 35 && this.res_cpf.cpreviaIzq <= 37);
               if (comp5 === true) {
                    this.res_cpf.rango = 5;
               }
               let comp6 = (this.res_cpf.cpreviaIzq >= 38 && this.res_cpf.cpreviaIzq <= 39);
               if (comp6 === true) {
                    this.res_cpf.rango = 6;
               }
               let comp7 = (this.res_cpf.cpreviaIzq >= 40 && this.res_cpf.cpreviaIzq <= 44);
               if (comp7 === true) {
                    this.res_cpf.rango = 7;
               }
               let comp8 = (this.res_cpf.cpreviaIzq >= 45 && this.res_cpf.cpreviaIzq <= 51);
               if (comp8 === true) {
                    this.res_cpf.rango = 8;
               }
               let comp9 = (this.res_cpf.cpreviaIzq >= 52 && this.res_cpf.cpreviaIzq <= 68);
               if (comp9 === true) {
                    this.res_cpf.rango = 9;
               }
               if (this.res_cpf.cpreviaDer >= 10) {
                    this.res_cpf.rango = this.res_cpf.rango - 1;
               }

               this.res_cpf.rangos = this.res_cpf.rango;
               console.log("El rango es ? ", this.res_cpf.rangos);
          }, // rangos()

          resultados(doc) {

               this.rangosnpf();

               doc.setLineWidth(0.25);

               doc.text(10, 70, "SECCION DE RESULTADOS ")
               doc.line(10, 71, 206, 71);

               doc.text(10, 74, "Conteo:       ( 0= ");
               doc.text(35, 74, this.res_cpf.Uno.toString());
               doc.text(38, 74, ", 1= ")
               doc.text(45, 74, this.res_cpf.Dos.toString());
               doc.text(49, 74, ", 2= ")
               doc.text(56, 74, this.res_cpf.Cero.toString());
               doc.text(59, 74, " )");

               doc.text(70, 74, "( 0= ");
               doc.text(78, 74, this.res_cpf.Uno2.toString());
               doc.text(81, 74, ", 1= ")
               doc.text(88, 74, this.res_cpf.Dos2.toString());
               doc.text(91, 74, ", 2= ")
               doc.text(98, 74, this.res_cpf.Cero2.toString());
               doc.text(101, 74, " )");

               doc.text(10, 80, "Resultados: [ ");
               doc.text(30, 80, this.res_cpf.cpreviaIzq.toString());
               doc.text(35, 80, ", ");
               doc.text(40, 80, this.res_cpf.cpreviaDer.toString());
               doc.text(45, 80, " ] ");

               doc.text(10, 85, "Rangos: ");
               doc.text(28, 85, this.res_cpf.rangos.toString());
          },
          respuestas(doc) {
               /* Muestra las preguntas */
               /* (izquierda, diangonal derecha abajo, largo, diagonal izquierda abajo) */
               doc.setLineWidth(0.25);

               doc.text(10, 40, "SECCION DE RESPUESTAS ")
               doc.line(10, 42, 206, 42);
               doc.text(10, 45, this.eval_cpf.pg001 === "a" ? "| 01= (a)" : this.eval_cpf.pg001 === "b" ? "| 01= (b)" : "| 01= (c)");
               doc.text(23, 45, this.eval_cpf.pg002 === "a" ? "| 02= (a)" : this.eval_cpf.pg002 === "b" ? "| 02= (b)" : "| 02= (c)");
               doc.text(36, 45, this.eval_cpf.pg003 === "a" ? "| 03= (a)" : this.eval_cpf.pg003 === "b" ? "| 03= (b)" : "| 03= (c)");
               doc.text(49, 45, this.eval_cpf.pg004 === "a" ? "| 04= (a)" : this.eval_cpf.pg004 === "b" ? "| 04= (b)" : "| 04= (c)");
               doc.text(62, 45, this.eval_cpf.pg005 === "a" ? "| 05= (a)" : this.eval_cpf.pg005 === "b" ? "| 05= (b)" : "| 05= (c)");
               doc.text(75, 45, this.eval_cpf.pg006 === "a" ? "| 06= (a)" : this.eval_cpf.pg006 === "b" ? "| 06= (b)" : "| 06= (c)");
               doc.text(88, 45, this.eval_cpf.pg007 === "a" ? "| 07= (a)" : this.eval_cpf.pg007 === "b" ? "| 07= (b)" : "| 07= (c)");
               doc.text(101, 45, this.eval_cpf.pg008 === "a" ? "| 08= (a)" : this.eval_cpf.pg008 === "b" ? "| 08= (b)" : "| 08= (c)");
               doc.text(114, 45, this.eval_cpf.pg009 === "a" ? "| 09= (a)" : this.eval_cpf.pg009 === "b" ? "| 09= (b)" : "| 09= (c)");
               doc.text(127, 45, this.eval_cpf.pg010 === "a" ? "| 10= (a)" : this.eval_cpf.pg010 === "b" ? "| 10= (b)" : "| 10= (c)");
               doc.text(140, 45, this.eval_cpf.pg011 === "a" ? "| 11= (a)" : this.eval_cpf.pg011 === "b" ? "| 11= (b)" : "| 11= (c)");
               doc.text(153, 45, this.eval_cpf.pg012 === "a" ? "| 12= (a)" : this.eval_cpf.pg012 === "b" ? "| 12= (b)" : "| 12= (c)");
               doc.text(166, 45, this.eval_cpf.pg013 === "a" ? "| 13= (a)" : this.eval_cpf.pg013 === "b" ? "| 13= (b)" : "| 13= (c)");
               doc.text(179, 45, this.eval_cpf.pg014 === "a" ? "| 14= (a)" : this.eval_cpf.pg014 === "b" ? "| 14= (b)" : "| 14= (c)");
               doc.text(192, 45, this.eval_cpf.pg015 === "a" ? "| 15= (a) |" : this.eval_cpf.pg015 === "b" ? "| 15= (b) |" : "| 15= (c) |");
               doc.line(10, 46, 206, 46);

               doc.text(10, 49, this.eval_cpf.pg016 === "a" ? "| 16= (a)" : this.eval_cpf.pg016 === "b" ? "| 16= (b)" : "| 16= (c)");
               doc.text(23, 49, this.eval_cpf.pg017 === "a" ? "| 17= (a)" : this.eval_cpf.pg017 === "b" ? "| 17= (b)" : "| 17= (c)");
               doc.text(36, 49, this.eval_cpf.pg018 === "a" ? "| 18= (a)" : this.eval_cpf.pg018 === "b" ? "| 18= (b)" : "| 18= (c)");
               doc.text(49, 49, this.eval_cpf.pg019 === "a" ? "| 19= (a)" : this.eval_cpf.pg019 === "b" ? "| 19= (b)" : "| 19= (c)");
               doc.text(62, 49, this.eval_cpf.pg020 === "a" ? "| 20= (a)" : this.eval_cpf.pg020 === "b" ? "| 20= (b)" : "| 20= (c)");
               doc.text(75, 49, this.eval_cpf.pg021 === "a" ? "| 21= (a)" : this.eval_cpf.pg021 === "b" ? "| 21= (b)" : "| 21= (c)");
               doc.text(88, 49, this.eval_cpf.pg022 === "a" ? "| 22= (a)" : this.eval_cpf.pg022 === "b" ? "| 22= (b)" : "| 22= (c)");
               doc.text(101, 49, this.eval_cpf.pg023 === "a" ? "| 23= (a)" : this.eval_cpf.pg023 === "b" ? "| 23= (b)" : "| 23= (c)");
               doc.text(114, 49, this.eval_cpf.pg024 === "a" ? "| 24= (a)" : this.eval_cpf.pg024 === "b" ? "| 24= (b)" : "| 24= (c)");
               doc.text(127, 49, this.eval_cpf.pg025 === "a" ? "| 25= (a)" : this.eval_cpf.pg025 === "b" ? "| 25= (b)" : "| 25= (c)");
               doc.text(140, 49, this.eval_cpf.pg026 === "a" ? "| 26= (a)" : this.eval_cpf.pg026 === "b" ? "| 26= (b)" : "| 26= (c)");
               doc.text(153, 49, this.eval_cpf.pg027 === "a" ? "| 27= (a)" : this.eval_cpf.pg027 === "b" ? "| 27= (b)" : "| 27= (c)");
               doc.text(166, 49, this.eval_cpf.pg028 === "a" ? "| 28= (a)" : this.eval_cpf.pg028 === "b" ? "| 28= (b)" : "| 28= (c)");
               doc.text(179, 49, this.eval_cpf.pg029 === "a" ? "| 29= (a)" : this.eval_cpf.pg029 === "b" ? "| 29= (b)" : "| 29= (c)");
               doc.text(192, 49, this.eval_cpf.pg030 === "a" ? "| 30= (a) |" : this.eval_cpf.pg030 === "b" ? "| 30= (b) |" : "| 30= (c) |");
               doc.line(10, 50, 206, 50);

               doc.text(10, 53, this.eval_cpf.pg031 === "a" ? "| 31= (a)" : this.eval_cpf.pg031 === "b" ? "| 31= (b)" : "| 31= (c)");
               doc.text(23, 53, this.eval_cpf.pg032 === "a" ? "| 32= (a)" : this.eval_cpf.pg032 === "b" ? "| 32= (b)" : "| 32= (c)");
               doc.text(36, 53, this.eval_cpf.pg033 === "a" ? "| 33= (a)" : this.eval_cpf.pg033 === "b" ? "| 33= (b)" : "| 33= (c)");
               doc.text(49, 53, this.eval_cpf.pg034 === "a" ? "| 34= (a)" : this.eval_cpf.pg034 === "b" ? "| 34= (b)" : "| 34= (c)");
               doc.text(62, 53, this.eval_cpf.pg035 === "a" ? "| 35= (a)" : this.eval_cpf.pg035 === "b" ? "| 35= (b)" : "| 35= (c)");
               doc.text(75, 53, this.eval_cpf.pg036 === "a" ? "| 36= (a)" : this.eval_cpf.pg036 === "b" ? "| 36= (b)" : "| 36= (c)");
               doc.text(88, 53, this.eval_cpf.pg037 === "a" ? "| 37= (a)" : this.eval_cpf.pg037 === "b" ? "| 37= (b)" : "| 37= (c)");
               doc.text(101, 53, this.eval_cpf.pg038 === "a" ? "| 38= (a)" : this.eval_cpf.pg038 === "b" ? "| 38= (b)" : "| 38= (c)");
               doc.text(114, 53, this.eval_cpf.pg039 === "a" ? "| 39= (a)" : this.eval_cpf.pg039 === "b" ? "| 39= (b)" : "| 39= (c)");
               doc.text(127, 53, this.eval_cpf.pg040 === "a" ? "| 40= (a)" : this.eval_cpf.pg040 === "b" ? "| 40= (b)" : "| 40= (c)");
               doc.line(10, 54, 141, 54);
          },
          ejeSinContestar: function () {

               this.ejeSinResponder = 0;
               console.log("1 ? ", this.ejemplo.pg001);
               if (this.ejemplo.pg001 === 0) { this.ejeSinResponder = this.ejeSinResponder + 1; }
               if (this.ejemplo.pg002 === 0) { this.ejeSinResponder = this.ejeSinResponder + 1; }
               if (this.ejemplo.pg003 === 0) { this.ejeSinResponder = this.ejeSinResponder + 1; }
               if (this.ejemplo.pg004 === 0) { this.ejeSinResponder = this.ejeSinResponder + 1; }
               if (this.ejemplo.pg005 === 0) { this.ejeSinResponder = this.ejeSinResponder + 1; }

               return this.ejeSinResponder;
          },
          sinContestar: function () {

               this.pregSinContestar = 0;

               if (this.eval_cpf.pg001 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_cpf.pg002 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_cpf.pg003 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_cpf.pg004 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_cpf.pg005 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_cpf.pg006 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_cpf.pg007 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_cpf.pg008 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_cpf.pg009 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_cpf.pg010 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_cpf.pg011 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_cpf.pg012 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_cpf.pg013 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_cpf.pg014 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_cpf.pg015 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_cpf.pg016 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_cpf.pg017 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_cpf.pg018 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_cpf.pg019 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_cpf.pg020 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_cpf.pg021 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_cpf.pg022 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_cpf.pg023 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_cpf.pg024 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_cpf.pg025 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }

               if (this.eval_cpf.pg026 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_cpf.pg027 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_cpf.pg028 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_cpf.pg029 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_cpf.pg030 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_cpf.pg031 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_cpf.pg032 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_cpf.pg033 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_cpf.pg034 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_cpf.pg035 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_cpf.pg036 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_cpf.pg037 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_cpf.pg038 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_cpf.pg039 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_cpf.pg040 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }

               return this.pregSinContestar;
          },
          addADayToMyDate() {
               if (this.eval_fecha) // as myDate can be null
                    // you have to set the this.myDate again, so vue can detect it changed
                    // this is not a caveat of this specific solution, but of any binding of dates
                    this.eval_cpf.empezo = new Date(this.eval_fecha.setDate(this.eval_fecha.getDate() + 1));
          },
          dateToYYYYMMDD(date) {
               console.log("***********************************************************************************");
               console.log("Estoy en dateToYYYYMMDD ");
               console.log("date ? ", date, "; typeof ", typeof (date));
               console.log("date.toISOString().split('T')[0] ? ", date.toISOString().split('T')[0]);
               console.log("date && date.toISOString().split('T')[0] ?", date && date.toISOString().split('T')[0]);

               console.log("Desmenuzando ...");
               var a = date.toISOString();
               var b = a.split("T");
               var c = b[0];
               var d = b[1];
               console.log("a) date.toISOString() ", date.toISOString());
               console.log("b) ", a.split("T"));
               console.log("c) b[0]", b[0], "; b[1] ", b[1]);
               console.log("***********************************************************************************");

               // may have timezone caveats https://stackoverflow.com/a/29774197/1850609
               return date && date.toISOString().split('T')[0]
          },
          cargaHora() {

               // Convierte la hora obtenida a hora local (utc)
               this.eval_fecha = new Date();
               var d = this.eval_fecha;
               var utcd = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(),
                    d.getMinutes(), d.getSeconds(), d.getMilliseconds());

               // obtain local UTC offset and convert to msec
               let localOffset = d.getTimezoneOffset() * 60000;
               var newdate = new Date(utcd + localOffset);
               var hours = newdate.getHours();
               var minutes = newdate.getMinutes();
               var seconds = newdate.getSeconds();
               var hora = hours + ":" + minutes + ":" + seconds;
               console.log("newdate ? ", newdate, " | ", hora);

               return hora;
          },
          cargaEvaluacion() {

               this.ejemplo = {
                    pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0,
               };

               this.eval_cpf = store.state.st_ev04;        // Crea el nodo para todos los campos.
               this.res_cpf = store.state.st_rs04;
               console.log("res ? ", this.res_16pf);

               this.eval_cpf.nombre = store.state.st_nusuario;    // Nombre del usuario que hará la evaluación
               this.eval_cpf.empresa = store.state.st_empresa;     // Nombre de la empresa a la cual pertenece el usuario
               this.eval_cpf.depto = store.state.st_depto;     // Nombre de la empresa a la cual pertenece el usuario
               this.eval_cpf.sexo = store.state.st_sexo;     // Nombre de la empresa a la cual pertenece el usuario

               this.instrucciones = this.eval_cpf.nombre.toUpperCase() + " haga click aqui para leer las instrucciones para responder la evaluación de SOCIABILIDAD."

               this.eval_fecha = new Date();                 // Fecha del Día
          },
          empezarEvaluacion() {

               this.eval_cpf.empezo = this.cargaHora();
               this.inicioeval = true;
          },
          /** .................... VALIDACIONES  .................... */
          validarValor(valor) {
               let lvalor = valor;
               if (valor < 1 || valor > 2) {
                    lvalor = 0;
               }
               // console.log("validarValor, lvalor ? ",lvalor);
               return lvalor;
          },
          limpiarEvaluacion() {

               this.ejemplo = {
                    pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0,
               };

               this.eval_cpf = {
                    depto: "",
                    empresa: "", nombre: "",
                    fecha: "",
                    empezo: "", termino: "",
                    pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0, pg006: 0, pg007: 0, pg008: 0, pg009: 0, pg010: 0,
                    pg011: 0, pg012: 0, pg013: 0, pg014: 0, pg015: 0, pg016: 0, pg017: 0, pg018: 0, pg019: 0, pg020: 0,
                    pg021: 0, pg022: 0, pg023: 0, pg024: 0, pg025: 0, pg026: 0, pg027: 0, pg028: 0, pg029: 0, pg030: 0,
                    pg031: 0, pg032: 0, pg033: 0, pg034: 0, pg035: 0, pg036: 0, pg037: 0, pg038: 0, pg039: 0, pg040: 0,
               }

               /* Variables para un nuevo caso */
               store.state.eval_cpf = this.eval_cpf;
          },
          /** .................... ACCIONES EN LA BASE DE DATOS  .................... */
          /* Acciones del Floatting Button: Agregar Encuesta */
          agregarEvaluacion() {

               if (this.pregSinContestar > 0) {
                    alert("No es posible grabar la Evaluación. \nAún tiene " + this.pregSinContestar + " preguntas sin responder.   ")
                    return
               }

               this.finalizoeval = true;
               this.eval_cpf.termino = this.cargaHora();

               this.eval_fecha = new Date();

               let ldia = this.eval_fecha.getDate();
               if (ldia <= 9) {
                    ldia = '0' + ldia.toString().trim();
               } else {
                    ldia = ldia.toString().trim();
               }
               let lmes = this.eval_fecha.getMonth() + 1;
               if (lmes <= 9) {
                    lmes = '0' + lmes.toString().trim();
               } else {
                    lmes = lmes.toString().trim();
               }
               console.log("dia ? ", ldia, ", mes ? ", lmes, ", anio ? ", this.eval_fecha.getFullYear());
               let lingreso = ldia + '/' + lmes + '/' + this.eval_fecha.getFullYear();


               console.log("*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-");
               console.log("** fecha de ingreso ? ", this.eval_fecha);
               console.log("** formato  ingreso ? ", lingreso);

               var confirma = confirm("Seguro de grabar la evaluación de SOCIABILIDAD para " + this.eval_cpf.nombre.toUpperCase().trim() + " ?");
               if (confirma === true) {

                    /* Agrega una colección al objeto */
                    var dbEvaluaciones = store.state.st_dbEvalSociab;
                    dbEvaluaciones.push({

                         empresa: this.eval_cpf.empresa, nombre: this.eval_cpf.nombre,
                         empezo: this.eval_cpf.empezo, termino: this.eval_cpf.termino,
                         fecha: lingreso, depto: this.eval_cpf.depto, sexo: this.eval_cpf.sexo,
                         pg001: this.eval_cpf.pg001, pg002: this.eval_cpf.pg002, pg003: this.eval_cpf.pg003, pg004: this.eval_cpf.pg004, pg005: this.eval_cpf.pg005,
                         pg006: this.eval_cpf.pg006, pg007: this.eval_cpf.pg007, pg008: this.eval_cpf.pg008, pg009: this.eval_cpf.pg009, pg010: this.eval_cpf.pg010,
                         pg011: this.eval_cpf.pg011, pg012: this.eval_cpf.pg012, pg013: this.eval_cpf.pg013, pg014: this.eval_cpf.pg014, pg015: this.eval_cpf.pg015,
                         pg016: this.eval_cpf.pg016, pg017: this.eval_cpf.pg017, pg018: this.eval_cpf.pg018, pg019: this.eval_cpf.pg019, pg020: this.eval_cpf.pg020,
                         pg021: this.eval_cpf.pg021, pg022: this.eval_cpf.pg022, pg023: this.eval_cpf.pg023, pg024: this.eval_cpf.pg024, pg025: this.eval_cpf.pg025,
                         pg026: this.eval_cpf.pg026, pg027: this.eval_cpf.pg027, pg028: this.eval_cpf.pg028, pg029: this.eval_cpf.pg029, pg030: this.eval_cpf.pg030,
                         pg031: this.eval_cpf.pg031, pg032: this.eval_cpf.pg032, pg033: this.eval_cpf.pg033, pg034: this.eval_cpf.pg034, pg035: this.eval_cpf.pg035,
                         pg036: this.eval_cpf.pg036, pg037: this.eval_cpf.pg037, pg038: this.eval_cpf.pg038, pg039: this.eval_cpf.pg039, pg040: this.eval_cpf.pg040,
                    }).then((data) => {

                         /* Inicializa las variables que captan los valores para el nuevo fcapturadatos */
                         this.limpiarEvaluacion();

                         var laClave = data.key;
                         this.grabado = true;
                         this.inicioeval = false;

                         // console.log("[culturaGforma- agregarEvaluacion], La clave almacenada es ? ",laClave);
                         alert("Evaluación de SOCIABILIDAD guardado con éxito.")
                    });
               } // if (confirma)
          }, // agregarEncuesta()

          //? =================================================================================
          enfoqueG1(pestana){

               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 2: //* Vengo de 1, voy a 2
                         Vue.nextTick().then(()=> this.$refs.testtt2.focus());

                         this.activott1="!active";
                         this.activott2="active";

                         this.vertt1=false;
                         this.vertt2=true;
                         break;
                    case 0: //* Vengo de 2, voy a 1
                         Vue.nextTick().then(()=> this.$refs.testtt1.focus());
                         this.activott2="!active";
                         this.activott1="active";

                         this.vertt2=false;
                         this.vertt1=true;
                         break;
                    default:                         
                    // code block
               } //* switch
          },
          nadaG1(pestana){
               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 1:
                         Vue.nextTick().then(()=> this.$refs.testtt1.focus());

                         this.activott1="active";
                         this.activott2="!active";

                         this.vertt1=true;
                         this.vertt2=false;

                         break;
                    case 2:
                         Vue.nextTick().then(()=> this.$refs.testtt2.focus());
                         this.activott1="!active";
                         this.activott2="active";

                         this.vertt1=false;
                         this.vertt2=true;

                         break;
                    default:                         
                    // code block
               } //* switch
          },
          enfoqueRG1(pestana){

               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 1:   //* Estoy en 2 regreso a 1
                         Vue.nextTick().then(()=> this.$refs.testtt1.focus());
                         this.activott2="!active";
                         this.activott1="active";

                         this.vertt2=false;                         
                         this.vertt1=true;
                         break;
                    default:                         
                    // code block
               } //* switch
          },
     }, // methods
} // export



// WEBPACK FOOTER //
// ./src/components/ev04_cpf.js